import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["tagName", "motion", "children"];
import { forwardRefWithMotionTag } from '@carnica/utils';
import React from 'react';
import { motion as motionComponents } from 'framer-motion';
export var MotionComponent = forwardRefWithMotionTag(function (props, ref) {
  var _props$tagName = props.tagName,
    tagName = _props$tagName === void 0 ? 'div' : _props$tagName,
    motion = props.motion,
    children = props.children,
    otherProps = _objectWithoutProperties(props, _excluded);
  var Tag = tagName;
  if (motion) {
    var Component = motionComponents[tagName];
    return /*#__PURE__*/React.createElement(Component, _extends({
      ref: ref
    }, otherProps), children);
  }
  return /*#__PURE__*/React.createElement(Tag, _extends({
    ref: ref
  }, otherProps), children);
});